<template>
    <!-- The server-made report, embedded. The three report screens share it: while the PDF is
         being produced the spinner turns inside the frame instead of locking the whole page,
         and a failure says so instead of leaving an empty box. -->
    <div class="pdf-frame" :class="{ 'is-waiting': !src }">
        <!-- Mounted only while loading: b-loading left its overlay up when :active turned false. -->
        <b-loading v-if="loading" :is-full-page="false" :active="true" :can-cancel="false"></b-loading>
        <p v-if="failed" class="pdf-frame-message">
            <span class="mdi mdi-alert-outline" aria-hidden="true"></span>
            {{ $lang.ReportPage.PdfFailed }}
        </p>
        <embed v-else-if="src" :src="src" type="application/pdf" />
    </div>
</template>

<script>
    export default {
        name: 'PdfFrame',
        props: {
            src: { type: String, default: '' },
            loading: { type: Boolean, default: false },
            failed: { type: Boolean, default: false }
        }
    };
</script>
